import { render, staticRenderFns } from "./part.vue?vue&type=template&id=3190d609"
import script from "./part.vue?vue&type=script&lang=js"
export * from "./part.vue?vue&type=script&lang=js"
import style0 from "./part.vue?vue&type=style&index=0&id=3190d609&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports